import { Select } from "@mimber/ui-web"
import { useOrganizations } from "@mimber/client/mimber-organization"
import { useState, useEffect } from "react"
import {
  getSelectedOrganizationId,
  setSelectedOrganizationId,
} from "@/utils/organization"
import type { OrganizationSelectorProps } from "./OrganizationSelector.types"

export const OrganizationSelector: React.FunctionComponent<
  OrganizationSelectorProps
> = ({ className, style }) => {
  const { data, isLoading } = useOrganizations()
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(() =>
    getSelectedOrganizationId()
  )

  const organizations = data?.data || []

  // Auto-select first organization if none selected
  useEffect(() => {
    if (!selectedOrgId && organizations.length > 0) {
      const firstOrgId = organizations[0].uuid
      setSelectedOrgId(firstOrgId)
      setSelectedOrganizationId(firstOrgId)
    }
  }, [selectedOrgId, organizations])

  const handleChange = (value: string) => {
    setSelectedOrgId(value)
    setSelectedOrganizationId(value)
    // Trigger page reload to update organization context
    window.location.reload()
  }

  if (isLoading) {
    return (
      <Select loading placeholder="Loading organizations..." style={style} />
    )
  }

  if (organizations.length === 0) {
    return <Select disabled placeholder="No organizations" style={style} />
  }

  return (
    <Select
      value={selectedOrgId || undefined}
      onChange={handleChange}
      placeholder="Select organization"
      className={className}
      style={{ minWidth: 200, ...style }}
      options={organizations.map((org) => ({
        label: org.name,
        value: org.uuid,
      }))}
    />
  )
}
